/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Duplicate_LineInputs */

const en_issue_duplicate_line = /** @type {(inputs: Issue_Duplicate_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is named more than once`)
};

/**
* | output |
* | --- |
* | "is named more than once" |
*
* @param {Issue_Duplicate_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_duplicate_line = /** @type {((inputs?: Issue_Duplicate_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Duplicate_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_duplicate_line(inputs)
});